<template>
    <on-click-outside :do="close">
        <div>
            <div class="py-2 relative">
                <input
                        class="focus:outline-none text-sm w-full rounded bg-grey-lighter p-2 pl-10 focus:bg-white border border-grey-lighter focus:border-blue-dark"
                        type="text"
                        ref="searchField"
                        placeholder="Search"
                        v-model="search.value"
                >
                <div class="absolute pin-y pin-l pl-3 flex items-center text-grey">
                    <i class="fa fa-search" v-show="!loading"></i>
                    <i class="fa fa-spin fa-spinner" v-show="loading"></i>
                </div>
                <div
                        v-show="search.value.length > 0"
                        @click="search.value = ''"
                        class="cursor-pointer absolute pin-y pin-r pr-3 flex items-center text-grey"
                >
                    <i class="fa fa-times"></i>
                </div>
                <div
                        class="absolute pt-2 w-full z-10"
                        v-if="open"
                >
                    <ul v-if="hasResults"
                        class="list-reset bg-white shadow border rounded pt-4 px-4 overflow-y-auto"
                        style="max-height: 50vh;">
                        <fetch-tree :database="database" :items="search.results" :codes="codes" :root="root">
                            <filter-search-item-root :codes="codes" :search="search"></filter-search-item-root>
                        </fetch-tree>

                        <database-filter-search-item
                                v-for="item in tree.root"
                                :model="item"
                                :key="item.id"
                        ></database-filter-search-item>

                    </ul>
                    <div class="bg-white shadow border rounded p-4" v-show="emptyResults">
                        no results
                    </div>
                </div>
            </div>
        </div>
    </on-click-outside>

</template>

<script>

    import FilterSearchItem from "./FilterSearchItem";
    import OnClickOutside from "../OnClickOutside";
    import FetchTree from "./FetchTree";
    import FilterSearchItemRoot from "./FilterSearchItemRoot";

    export default {

        props: {
            'codes': Object,
            'database': {
                type: String,
                required: true,
            },
            'root': String,
        },

        components: {
            FilterSearchItemRoot,
            FetchTree,
            OnClickOutside,
            DatabaseFilterSearchItem: FilterSearchItem,
        },

        data() {
            return {
                search: {
                    value: '',
                    results: [],
                },
                loading: false,
                source: {},
                CancelToken: {},
                open: false,
                tree: {
                    database: this.database,
                    opened: [],
                    loaded: [], // which nodes do we need to load!
                    required: [], // nodes that are required to restore from loading.
                    nodes: [],
                    root: [],
                    visible: null, // decide if a node is visible
                    loading: [], // nodes currently under load.
                    items: {},
                },
            };
        },

        watch: {
            'search.value': function (val) {
                this.doSearch(val);
            },
        },

        computed: {
            hasResults() {
                return this.loading === false
                    && this.tree
                    && this.tree.visible
                    && this.tree.visible.length > 0
                    && this.search.value.length > 0;
            },
            emptyResults() {
                return !this.loading
                    && this.tree
                    && this.tree.visible
                    && this.tree.visible.length === 0
                    && this.search.value.length > 0;
            },
        },

        mounted() {
            this.CancelToken = window.http.CancelToken;
            this.source = this.CancelToken.source();
        },

        methods: {
            close() {
                this.open = false;
            },
            doSearch(value) {

                this.tree.visible = null;

                if (value.length === 0) {
                    return;
                }

                this.loading = true;

                // canceling is not reliable
                const CancelToken = window.http.CancelToken;
                if (this.source !== null) {
                    this.source.cancel('');
                }
                this.source = CancelToken.source();

                // close the tree
                this.tree.visible = [];
                this.tree.opened = [];
                this.tree.required = [];

                let that = this;
                window.http.get(
                    '/api/v1/indicators/' + this.tree.database + '/search?lang=en&str=' + value, {
                        cancelToken: this.source.token,
                    })
                    .then(function (response) {
                        that.open = true;
                        that.loading = false;
                        that.source = null;

                        if (value !== that.search.value) {
                            // search has changed.. we ignore the result
                            return;
                        }
                        that.search.results = response.data;

                        that.tree.visible = response.data;
                        that.tree.opened = response.data;
                    })
                    .catch(function (thrown) {
                        if (window.http.isCancel(thrown)) {
                        } else {
                            that.loading = false;
                        }
                    });

            }
        },

    }

</script>